module.exports = __webpack_public_path__ + "img/twitter2.37caa662.svg";